export default "__VITE_ASSET__HQRPmcjw__"